import { render } from "./PartnerAdd.vue?vue&type=template&id=a14867e8"
import script from "./PartnerAdd.vue?vue&type=script&lang=js"
export * from "./PartnerAdd.vue?vue&type=script&lang=js"

import "./PartnerAdd.vue?vue&type=style&index=0&id=a14867e8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__